import request from '@/utils/request'

// 朋友圈列表
export function momentsList(params = {}) {
  return request({
    url: '/spWorkWechat/moments/momentsList',
    method: 'get',
    params
  })
}// 朋友圈列表
export function momentsDel(data = {}) {
  return request({
    url: '/spWorkWechat/moments/momentsDel',
    method: 'post',
    data
  })
}

// 朋友圈详情
export function momentsDetail(params = {}) {
  return request({
    url: '/spWorkWechat/moments/momentsDetail',
    method: 'get',
    params
  })
}

// 朋友圈创建
export function momentsCreate(data) {
  return request({
    url: '/spWorkWechat/moments/momentsCreate',
    method: 'post',
    data
  })
}

// 朋友圈编辑
export function momentsUpdate(data) {
  return request({
    url: '/spWorkWechat/moments/momentsUpdate',
    method: 'post',
    data
  })
}

// 创建文章配置
export function articleSettingstore(data) {
  return request({
    url: '/appletVideo/articleSetting/store',
    method: 'post',
    data
  })
}

// 文章列表
export function articleSettinglist(params = {}) {
  return request({
    url: '/appletVideo/articleSetting/list',
    method: 'get',
    params
  })
}

// 文章小程序列表包括已绑定
export function getAppletAndBind(params = {}) {
  return request({
    url: '/appletVideo/articleSetting/getAppletAndBind',
    method: 'get',
    params
  })
}

// 更新文章配置
export function articleSettingupdate(data) {
  return request({
    url: '/appletVideo/articleSetting/update',
    method: 'post',
    data
  })
}

// 编辑时选择的小程序列表
export function articleSettinggetAppletAndBind(params) {
  return request({
    url: '/appletVideo/articleSetting/getAppletAndBind',
    method: 'get',
    params
  })
}

// 删除文章
export function articleSettingdelete(data) {
  return request({
    url: '/appletVideo/articleSetting/delete',
    method: 'post',
    data
  })
}

// 文章绑定小程序记录
export function articleBindAppletRecord(params) {
  return request({
    url: '/appletVideo/articleSetting/articleBindAppletRecord',
    method: 'get',
    params
  })
}

// 文章解绑小程序
export function articleUnBindApplet(data) {
  return request({
    url: '/appletVideo/articleSetting/articleUnBindApplet',
    method: 'post',
    data
  })
}

// 文章详情
export function articleSettingdetails(params) {
  return request({
    url: '/appletVideo/articleSetting/details',
    method: 'get',
    params
  })
}
// 任务类型列表记录
export function workWechatcodeList(params) {
  return request({
    url: '/workWechat/phone/codeList',
    method: 'get',
    params
  })
}
// 任务列表
export function spWorkWechatlistr(params) {
  return request({
    url: '/spWorkWechat/wwScriptJob/index',
    method: 'get',
    params
  })
}
// 获取广告企业列表
export function getcorpList(params) {
  return request({
    url: '/ad_corp/getCorpList',
    method: 'get',
    params
  })
}
// 广告企业下员工
export function getwechatcorpuser(params) {
  return request({
    url: '/ad_corp/getWechatCorpUser',
    method: 'get',
    params
  })
}
// 广告企业微信客服组
export function getcorpcsgrouplist(params) {
  return request({
    url: '/ad_corp/getCorpCsGroupList',
    method: 'get',
    params
  })
}
// 广告企业微信客服集合
export function adGroupSetList(params) {
  return request({
    url: '/ad_corp/adGroupSetList',
    method: 'get',
    params
  })
}
// 企业微信备用客服
export function getWechatCorpStandbyUser(params) {
  return request({
    url: '/ad_corp/getWechatCorpStandbyUser',
    method: 'get',
    params
  })
}
// 设置备用客服（开）
export function addWechatCorpStandbyUser(data) {
  return request({
    url: '/ad_corp/addWechatCorpStandbyUser',
    method: 'post',
    data
  })
}
// 设置备用客服（关）
export function removeWechatCorpStandbyUser(data) {
  return request({
    url: '/ad_corp/removeWechatCorpStandbyUser',
    method: 'post',
    data
  })
}
// 修改客服组
export function updateCorpCsGroupal(data) {
  return request({
    url: '/ad_corp/updateCorpCsGroup',
    method: 'post',
    data
  })
}
// 修改客服组输入框
export function updateClickAddNumber(data) {
  return request({
    url: '/ad_corp/updateClickAddNumber',
    method: 'post',
    data
  })
}
// 修改客服集合输入框
export function updateClickAddNumberAdGroupSet(data) {
  return request({
    url: '/ad_corp/updateClickAddNumberAdGroupSet',
    method: 'post',
    data
  })
}
// 修改客服组分钟输入框
export function updateEstimatedMaxTime(data) {
  return request({
    url: '/ad_corp/updateEstimatedMaxTime',
    method: 'post',
    data
  })
}
// 修改客服集分钟输入框
export function updateEstimatedMaxTimeAdGroupSet(data) {
  return request({
    url: '/ad_corp/updateEstimatedMaxTimeAdGroupSet',
    method: 'post',
    data
  })
}
// 修改状态
export function inweqwinfduiwe(data) {
  return request({
    url: '/appletVideo/articleSetting/setDefault',
    method: 'post',
    data
  })
}
// 获取鉴权 URL
export function dingdingauthurl(params = {}) {
  return request({
    url: '/auth/casdoor',
    method: 'get',
    params
  })
}
